import { render, staticRenderFns } from "./get-started-page.vue?vue&type=template&id=339f4af6&scoped=true&"
import script from "./get-started-page.vue?vue&type=script&lang=js&"
export * from "./get-started-page.vue?vue&type=script&lang=js&"
import style0 from "./get-started-page.vue?vue&type=style&index=0&id=339f4af6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339f4af6",
  null
  
)

export default component.exports